<div>
  <app-alert
    style="margin-bottom: 32px"
    class="flex-col-container mb-8 mt-24"
    type="warning"
    icon="warning_amber"
    lineHeight="lh-1"
    [message]="question | translate"></app-alert>
  <p class="my-10">{{ statement | translate}}</p>

  <div class="p-16 flex-row-container items-center b-0-5 rounded">
    <img class="mr-8" src="assets/svg/account_exoneration.svg" alt="rappi logo" />
    <div class="flex-col-container start flex-1 ml-4">
      <span class="fw-500">{{ 'MODAL_BLOCK_ACC.ACCOUNT_NUMBER' | translate}}</span>
      <span>{{account?.external_number}}</span>
    </div>
    <app-read-only
      [descColor]="account?.status === STATUS.ENABLE ? 'success' : 'warning'"
      [applyBorderBottom]="false"
      [value]="account?.status"></app-read-only>
  </div>

  <form class="w-95 m-auto" [formGroup]="blockAccountForm">
    <mat-form-field class="w-all mt-15 px-8"> 
      <mat-label>{{ selectLabel | translate}}</mat-label>
      <mat-select class="select-padding" formControlName="reason" (selectionChange)="getTypeByReason($event.value)">
        <mat-option *ngFor="let reason of roles" [value]="reason.block_reason_id"> {{ reason.name }} </mat-option>
      </mat-select>
    </mat-form-field>
  </form>
</div>
